<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rekam Medis" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="mutateSuccess"
            :alert="{
              title: 'Berhasil menyimpan mutasi',
              type: 'success',
              content: `Mutasi Berkas rekam medis berhasil disimpan`,
            }"
          />
          <Alert
            v-if="mutateFailed"
            :alert="{
              title: 'Gagal menyimpan mutasi',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Mutasi Berkas rekam medis gagal disimpan`,
            }"
          />
          <div class="card-with-tab my-3">
            <div class="card-tab">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <router-link to="/pasien" class="nav-link"
                    >Data Rekam Medis</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pasien/mutasi" class="nav-link active"
                    >Mutasi Berkas</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pasien/retensi" class="nav-link"
                    >Upload Berkas Fisik</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <!-- @each(input in filters) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
                <!-- @mutateeach -->
              </div>
              <div class="col-md-2">
                <!-- @each(input in sort) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
                <!-- @mutateeach -->
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row" v-if="rows && rows.length">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25">
                        25 data
                      </option>
                      <option v-if="rows.length > 25" value="50">
                        50 data
                      </option>
                      <option v-if="rows.length > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              :columns="columns"
              :per-page="10"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
              v-if="loaded && rows.length"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{
                img: '/img/med.svg',
                size: 'small',
                title: `Tidak ada data mutasi berkas dengan filter di atas'`,
                content:
                  'Tambahkan mutasi dengan mengeklik tombol + Mutasi Berkas Baru di atas',
              }"
            />
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ rows.length > parseInt(perPage) ? perPage : rows.length }} data
              dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
              v-if="loaded && rows.length"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="'cancel' + row.id + Math.random(1024)"
      :id="'cancel' + row.id"
      @click="
        () => {
          cancel(row.id, `${row.no_rm} - ${row.nama}`);
        }
      "
      style="display: none"
    ></button>
    <button
      v-for="row in rows"
      v-bind:key="'mutate' + row.id + Math.random(1024)"
      :id="'mutate' + row.id"
      @click="
        () => {
          mutate(row.id, `${row.no_rm} - ${row.nama}`, row.lokasi, row.status);
        }
      "
      style="display: none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk membatalkan mutasi berkas berikut?
            </p>
            <h4>{{ cancelItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btncancelItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmCancel(cancelItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal class="modal modal-confirm" id="modalMutate" size="lg">
      <template #modal-title>
        <p class="mb-1">Update Berkas Rekam Medis</p>
        <h5 class="mb-0 text-left text-primary">{{ mutateItem.name }}</h5>
      </template>
      <div class="container">
        <FormRow
          v-for="row in form"
          v-bind:key="row.colnum + String(Math.random(1023))"
          :row="row"
          @handleChange="(e) => mutateChange(e)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button
            id="btnmutateItem"
            class="btn btn-primary float-right"
            @click="
              () => {
                confirmMutate(mutateItem.id);
              }
            "
          >
            SIMPAN MUTASI
          </button>
          <button
            type="button"
            class="btn btn-outline-primary mr-3 float-right"
            @click="$bvModal.hide('modalMutate')"
          >
            BATAL
          </button>
        </div>
      </template>
    </b-modal>
    <b-modal class="modal modal-confirm" id="modalMutateNew" size="lg">
      <template #modal-title>
        <p class="mb-1">Mutasi Berkas Rekam Medis Baru</p>
      </template>
      <div class="container">
        <FormRow
          v-for="row in formNew"
          v-bind:key="row.colnum + String(Math.random(1023))"
          :row="row"
          @handleChange="(e) => mutateChange(e, true)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button
            id="btnmutateItemNew"
            class="btn btn-primary float-right"
            @click="
              () => {
                confirmMutateNew();
              }
            "
          >
            SIMPAN MUTASI
          </button>
          <button
            type="button"
            class="btn btn-outline-primary mr-3 float-right"
            @click="$bvModal.hide('modalMutateNew')"
          >
            BATAL
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import EmptyState from "@/components/EmptyState.vue";
let data = {
  title: "Mutasi Berkas Rekam Medis",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Mutasi Berkas Baru",
      link: "#modalMutate",
      function: () => {},
      type: "function",
      iconLeft: "add",
    },
  ],
  breadcrumb: [],
};
let tabs = [
  { title: "DIJADWALKAN", link: "#", filter: "DIJADWALKAN", active: true },
  { title: "BERLANGSUNG", link: "#", filter: "BERLANGSUNG" },
  { title: "SELESAI", filter: "SELESAI", link: "#selesai" },
  { title: "DIBATALKAN", filter: "DIBATALKAN", link: "#selesai" },
];

// let lokasi = ["Pendaftaran","Rawat Jalan","Rekam Medis","Ophthalmic","Nurse Station","Pelayanan","Ruang Operasi","Apotik","Optik","Kasir"];
// let lokasiOption = lokasi.map((item)=>{
//   return { value:item,label:item };
// })

let status = ["Dipinjam", "Dikembalikan"];
let statusOption = status.map((item) => {
  return { value: item, label: item };
});

export let sorts = [
  {
    value: "desc",
    label: "Terbaru",
  },
  {
    value: "asc",
    label: "Terlama",
  },
];
let filters = {
  colnum: "",
  columns: [
    {
      label: "tanggal",
      type: "date",
      placeholder: "Tanggal",
      name: "created_at",
      value: "",
      mandatory: true,
      colwidth: 6,
      id: "filterDateStart",
    },
  ],
};
let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts,
      name: "orderBy",
    },
  ],
};
let doubleDigit = function(value) {
  let stringValue = String(value);
  if (value < 10) {
    stringValue = "0" + stringValue;
  }
  return stringValue;
};
let today = new Date();
// let time=today.getTime();
let time =
  doubleDigit(today.getHours()) +
  ":" +
  doubleDigit(today.getMinutes()) +
  ":" +
  doubleDigit(today.getSeconds());
//console.log(time);
let form = [
  {
    colnum: 2,
    class: "",
    columns: [
      {
        label: "Posisi Berkas",
        type: "select",
        placeholder: "Pilih Posisi Berkas",
        name: "lokasi",
        value: "",
        options: [],
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Status",
        type: "select",
        placeholder: "Pilih Status",
        name: "status",
        value: "",
        options: statusOption,
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
    ],
  },
];
let formNew = [
  {
    colnum: 3,
    class: "",
    columns: [
      {
        label: "Berkas Rekam Medis Pasien",
        type: "select",
        placeholder: "Pilih Pasien",
        name: "no_rm",
        value: "",
        options: [],
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Posisi Berkas",
        type: "select",
        placeholder: "Pilih Posisi Berkas",
        name: "lokasi",
        value: "",
        options: [],
        mandatory: true,
        additional: "",
        colwidth: "3",
      },
      {
        label: "Status",
        type: "select",
        placeholder: "Pilih Status",
        name: "status",
        value: "",
        options: statusOption,
        mandatory: true,
        additional: "",
        colwidth: "3",
      },
    ],
  },
];
export default {
  name: "PasienMutasi",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      form: form,
      formNew: formNew,
      posisi: "Rekam Medis",
      status: "",
      dgs_keluar: "",
      prognosa: "",
      tgl_keluar: "",
      jam_keluar: time,
      cancelSuccess: false,
      cancelFailed: false,
      mutateSuccess: false,
      mutateFailed: false,
      cancelItem: { id: null, name: "" },
      mutateItem: { id: null, name: "", lokasi: null, status: "" },
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      allRooms: [],
      created_at: "",
      orderBy: "desc",
      kamar_pasien_kelas: "",
      kamar_pasien_nama: "",
      columns: [
        {
          label: "No. RM",
          field: "no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "nama" },
        { label: "Lokasi", field: "nama_lokasi" },
        { label: "Diperbarui Pada", field: "updated_at" },
        { label: "Diperbarui Oleh", field: "updated_by" },
        { label: "Status", field: "status" },
        {
          label: "",
          class: "dropdown",
          representedAs: (item) =>
            `<a class="btn btn-sm btn-outline-success btn-with-icon-left" data-toggle="modal" onclick="document.getElementById('mutate${item.id}').click()"><i class="material-symbols-outlined">create</i>Update Status</a>`,
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
      formSet: {
        lokasi: null,
        status: "",
      },
      formNewSet: {
        no_rm: "",
        lokasi: null,
        status: "",
      },
    };
  },
  methods: {
    mutateChange(e, create) {
      if (create) {
        //console.log('reset new form');
        this.formNewSet[e.target.name] = e.target.value;
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      //console.log(e.target.name);
      //console.log(this[e.target.name])
    },
    handleForm: async function(formset, form, id) {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      let valid = this.validateForm(formset, form);
      //console.log(valid);
      if (valid) {
        Object.keys(formset).forEach(function(key) {
          formData.append(key, formset[key]);
        });
        try {
          let result;
          if (id) {
            result = await this.$store.state.HTTP.post(
              `mutasi/${id}`,
              formData
            );
          } else {
            result = await this.$store.state.HTTP.post("mutasi", formData);
          }
          if (result.status == "200") {
            await this.displayList();
            this.$nextTick(() => {
              if (this.$refs.focusMe) {
                this.$refs.focusMe.focus();
              }
            });
            if (id) {
              this.$bvModal.hide("modalMutate");
            } else {
              this.$bvModal.hide("modalMutateNew");
            }
            this.mutateSuccess = true;
          } else {
            this.errors.push(result.status);
            this.mutateFailed = true;
          }
        } catch (e) {
          this.errors.push(e);
          this.mutateFailed = true;
        }
      } else {
        //console.log(valid);
      }
      this.resetAlert();
    },
    validateForm: function(formset, form) {
      let valid = true;
      //console.log(formset);
      form = form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            (!formset[column.name] || formset[column.name] == -1)
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
            //console.log(valid);
          } else {
            column.error = "";
          }
          column.value = String(formset[column.name]);
          return column;
        });
        return row;
      });
      //console.log(form);
      return valid;
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    displayList: async function() {
      this.page = 1;
      this.loaded = false;
      this.errors = [];
      try {
        let params = "?per_page=99999999&";
        if (this.created_at) {
          params += `created_at=${this.created_at}&`;
        }
        if (this.orderBy) {
          params += `orderBy=${this.orderBy}`;
        }
        let result = await this.$store.state.HTTP.get(`mutasi${params}`);
        //console.log(result);
        let resultNew = await this.$store.state.HTTP.get("lokasi");
        const locations = {};
        for (const item of resultNew.data.data) {
          locations[item.id] = item.nama;
        }
        let lokasiOption = resultNew.data.data.map((item) => {
          return { value: item.id, label: item.nama };
        });
        this.form[0].columns[0].options = lokasiOption;
        this.formNew[0].columns[1].options = lokasiOption;
        if (result.status == "200") {
          this.rows = [];
          //console.log(locations);
          //console.log(resultNew);
          //console.log(result.data.data);
          this.rows = result.data.data.map((item) => {
            return {
              id: item.id,
              no_rm: item.no_rm,
              nama: item.nama_pasien,
              lokasi: item.lokasi,
              nama_lokasi: locations[item.lokasi],
              updated_at: item.formatted_updated_at,
              updated_by: item.user.name,
              status: item.status,
            };
          });
          this.fetchPasien();

          this.loaded = true;
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    cancel: async function(id, name) {
      this.cancelItem = {
        id: id,
        name: name,
      };
    },
    mutate: async function(id, name, lokasi, status) {
      this.mutateItem = {
        id,
        name,
        lokasi,
        status,
      };
      let self = this;
      Object.keys(this.formSet).forEach(function(key) {
        //console.log(key);
        self.formSet[key] = self.mutateItem[key];
      });
      this.updateForm(this.formSet, this.form);
      this.$bvModal.show("modalMutate");
    },
    mutateNew: async function() {
      let self = this;
      //console.log('mashooku');
      Object.keys(this.formNewSet).forEach(function(key) {
        //console.log(key);
        self.formNewSet[key] = -1;
      });
      this.updateForm(this.formNewSet, this.formNew, true);
      this.$bvModal.show("modalMutateNew");
    },
    updateForm(formset, form, create) {
      let self = this;
      form = form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (formset[column.name]) {
            column.value = formset[column.name];
            self.mutateChange(
              {
                target: {
                  value: column.value,
                  name: column.name,
                  type: column.type,
                },
              },
              create
            );
          }
          return column;
        });
        return row;
      });
      return form;
    },
    async confirmMutateNew() {
      this.handleForm(this.formNewSet, this.formNew);
    },
    async confirmMutate(id) {
      this.handleForm(this.formSet, this.form, id);
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.cancelSuccess = false;
        self.mutateSuccess = false;
        self.cancelFailed = false;
        self.mutateFailed = false;
      }, 5000);
    },
    async fetchPasien() {
      let rows = this.rows;
      let params = "?per_page=99999999&";
      let resultPasien = await this.$store.state.HTTP.get(`pasien${params}`);
      // //console.log(resultPasien);
      this.formNew[0].columns[0].options = resultPasien.data.data
        .filter((item) => {
          return !this.mutationExist(item.no_rm, rows);
        })
        .map((item) => {
          return { label: `[${item.no_rm}] - ${item.nama}`, value: item.no_rm };
        });
    },
    mutationExist(no_rm, mutations) {
      var exist = false;
      for (const item of mutations) {
        if (item.no_rm == no_rm) {
          exist = true;
          break;
        }
      }
      return exist;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    this.data.actionBtn[0].function = () => this.mutateNew();
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
